import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-added-value',
  templateUrl: './added-value.component.html',
  styleUrls: ['./added-value.component.scss']
})
export class AddedValueComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
